import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import style from 'feature/auth/AuthForm.module.scss'

type Props = {
  email: string
  isLoading: boolean
  blockedTime: number
  onResend: () => void
  onChangeEmail: () => void
}

export function MagicLinkSentInfo({
  email,
  isLoading,
  blockedTime,
  onResend,
  onChangeEmail,
}: Props) {
  const [count, setCount] = useState(blockedTime)

  useEffect(() => {
    setCount(blockedTime)
  }, [blockedTime])

  useEffect(() => {
    if (count <= 0) return
    const timer = setInterval(() => {
      setCount(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [count > 0])

  const minutes = Math.floor(count / 60)
  const seconds = count - minutes * 60
  const timerText = `${String(minutes).padStart(2, '0')}:${String(
    seconds,
  ).padStart(2, '0')}`

  return (
    <div className={classNames(style.formWrapper, 'mt24')}>
      <form className={style.authForm}>
        <MailOutlineIcon
          color='primary'
          sx={{ fontSize: 48, marginBottom: '16px' }}
        />
        <p className='h1'>Проверьте почту</p>
        <p className={classNames(style.subtitle, 'mb24')}>
          Мы отправили ссылку для входа на {email}
        </p>

        {count > 0 ? (
          <p className={classNames(style.subtitle, style.secondaryText)}>
            Повторная отправка через {timerText}
          </p>
        ) : (
          <Button
            className={style.btn}
            variant='contained'
            onClick={onResend}
            disabled={isLoading}
            data-testid='company-login-resend'
          >
            {isLoading && <LoaderInCentalPosition className={style.loader} />}
            Отправить повторно
          </Button>
        )}
      </form>

      <Button
        type='button'
        variant='contained'
        className={style.backButton}
        color='secondary'
        startIcon={<ChevronLeftIcon color='primary' />}
        onClick={onChangeEmail}
        data-testid='company-login-change-email'
      >
        Назад
      </Button>
    </div>
  )
}
